import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    marginTop: theme.spacing(1),
  },
  scroll: {
    overflowX: 'auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
  },
  table: {
    width: '100%',
    minWidth: 1120,
    tableLayout: 'fixed',
  },
  name: {
    width: '16%',
  },
  doc: {
    width: '12%',
  },
  headRow: {
    background: theme.palette.grey[100],
    '& th': {
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 0.4,
      textTransform: 'uppercase',
      color: theme.palette.text.secondary,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  bodyRow: {
    '&:nth-of-type(even)': {
      background: theme.palette.grey[50],
    },
    '&:hover': {
      background: theme.palette.action.hover,
    },
    '& td': {
      borderBottom: `1px solid ${theme.palette.divider}`,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      verticalAlign: 'top',
    },
  },
  idx: {
    width: 48,
    textAlign: 'center',
  },
  narrow: {
    width: 116,
  },
  mid: {
    width: 148,
  },
  city: {
    width: 220,
  },
  cityError: {
    display: 'block',
    marginTop: 3,
    marginLeft: 14,
    fontSize: '0.75rem',
    color: theme.palette.error.main,
  },
  addBtn: {
    marginTop: theme.spacing(2),
  },
}));
